module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showPositionLegend) ? _c('div', {
    staticClass: "mdl-typography--caption typography--color-secondary number-line-legend-container text-left"
  }, [_c('span', {
    staticClass: "position-label"
  }), _vm._v("\n    평균 점수\n    "), _c('span', {
    staticClass: "typography--font-weight-500 position-score"
  }, [_vm._v(_vm._s(_vm.avgScore) + "점")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "number-line-container"
  }, [_c('div', {
    staticClass: "nl-baseline"
  }, [_vm._l((11), function(_, index) {
    return _c('div', {
      key: index,
      staticClass: "nl-tick",
      style: ({
        left: ((index * 10) + "%")
      })
    })
  }), _vm._v(" "), _c('small', {
    staticClass: "nl-start-label typography--color-disabled"
  }, [_vm._v("0점")]), _vm._v(" "), _c('small', {
    staticClass: "nl-end-label typography--color-disabled"
  }, [_vm._v("100점")]), _vm._v(" "), _c('div', {
    staticClass: "nl-my-position",
    style: ({
      left: (_vm.myScore + "%")
    })
  }, [_c('div', {
    staticClass: "position-icon"
  }), _vm._v(" "), (_vm.showPositionLabel) ? _c('small', {
    staticClass: "nl-position-label"
  }, [_vm._v("나")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "nl-avg-position",
    style: ({
      left: (_vm.avgScore + "%")
    })
  }, [_c('div', {
    staticClass: "position-icon"
  })])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c838558e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BasicNumberLine.vue
// module id = 1609
// module chunks = 1